import React, { useEffect, useRef } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Button } from '../..';
import keyCodeConverter from '../../../utility/keyCodeConverter';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    padding: 'unset',
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

type Props = ButtonProps & {
  submitHandler: () => void;
};

const FormSubmit = ({
  submitHandler,
  children,
  disabled,
  classes,
  ...props
}: Props) => {
  const styles = useStyles();
  const refSubmit = useRef<HTMLButtonElement>(null);
  // const { formState, handleSubmit } = useFormContext();

  useEffect(() => {
    const save = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === keyCodeConverter('s') && !disabled) { // formState.isValid
        event.preventDefault();
        refSubmit.current?.click();
      }
    };
    window.addEventListener('keydown', save);
    return () => {
      window.removeEventListener('keydown', save);
    };
  }, [refSubmit, disabled]); // formState

  return (
    <Button
      onClick={() => submitHandler()}
      disabled={disabled} // !formState.isValid
      ref={refSubmit}
      type="submit"
      classes={{
        ...styles,
        ...classes,
      }}

      {...props}
    >
      {children}
    </Button>
  );
};

export default FormSubmit;
